export const getSourceNameByCategory = (eachSource: any) => {
  switch (eachSource.category_code) {
    case "Category-1.1":
      return "Source";

    case "Category 3.5": {
      switch (eachSource?.sub_type_name) {
        case "Remote Work (IFI 2021)":
          return "Environment type";
        case "Hotel Stay (Hotel Sustainbility Benchmark - Cornell)":
          return "Country";
        default:
          return "Source";
      }
    }
    default:
      return "Source";
  }
};

export const getSourceValue = (eachSource: any, eachLog: any) => {
  if (eachLog && eachSource) {
    switch (eachSource?.category_code) {
      case "Category 3.5": {
        switch (eachSource.sub_type_name) {
          case "Hotel Stay (Hotel Sustainability Benchmark - Cornell)":
            return eachLog.country_name;
          case "Remote Work (IFI 2021)":
            return eachLog.country_name + " - " + eachLog.emission_source;
          default: {
            if (
              eachSource.sub_type_name === "UK (DESNZ)" &&
              eachSource.method_name ===
                "Total number of nights for all the rooms combined"
            ) {
              return eachLog.country_name;
            }
            return (
              eachLog?.emission_source +
                (eachLog?.sub_source_name
                  ? " - " + eachLog?.sub_source_name
                  : "") || " - "
            );
          }
        }
      }
      default:
        return (
          eachLog?.emission_source +
            (eachLog?.sub_source_name
              ? " - " + eachLog?.sub_source_name
              : " ") || " - "
        );
    }
  }
};
